import type React from 'react'
import { Button, type ButtonProps, styled } from '@mui/material'

interface FilterButtonProps extends Omit<ButtonProps, 'variant'> {
  variant?: 'text' | 'outlined' | 'contained' | 'white'
}

const StyledButton = styled(Button, {
  shouldForwardProp: (prop) => prop !== 'isWhite',
})<{ isWhite?: boolean }>(({ isWhite }) => ({
  ...(isWhite && {
    backgroundColor: '#ffffff',
    color: '#000000',
    border: '1px solid #EDEFF2',
    textTransform: 'none',
    fontWeight: 500,
    boxShadow: 'none',
    '&:hover': {
      backgroundColor: '#f5f5f5',
    },
    '&:active': {
      backgroundColor: '#eeeeee',
    },
    '&:focus': {
      backgroundColor: '#f5f5f5',
    },
    '&:disabled': {
      backgroundColor: '#f9f9f9',
      color: '#bdbdbd',
      border: '1px solid #e0e0e0',
    },
  }),
}))

const FilterButton: React.FC<FilterButtonProps> = ({ variant = 'contained', ...props }) => {
  const isWhiteVariant = variant === 'white'
  const muiVariant = isWhiteVariant ? 'contained' : variant

  return (
    <StyledButton
      variant={muiVariant as ButtonProps['variant']}
      isWhite={isWhiteVariant}
      {...props}
    />
  )
}

export default FilterButton
